module.exports = __webpack_public_path__ + "static/media/worshipbell2.6ce67c9d.ogg";